// extracted by mini-css-extract-plugin
export var selected = "styles-module--selected--7f4c1";
export var thumbs = "styles-module--thumbs--494d8";